// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1ed7f304","78":"c1cdad2c","143":"fb316349","151":"1a49c4df","180":"d655e59c","328":"58ce37d9","331":"fa913f45","515":"b6cf5fc2","760":"9d26e963","869":"c95d04c7","948":"3a453d48","953":"948dde3a"}[chunkId] + ".chunk.js";
};